export default __webpack_public_path__ + "static/media/Americantourister1.922ed38d.jpg";